import React from "react";
import clsx from "clsx";

export const LeftSideBarCol: React.FC<{ className?: string; children?: React.ReactNode }> = ({
  className,
  children,
}) => (
  <div className={clsx("max-[1000px]:hidden flex-none w-[108px] pl-0 pr-0", className)}>
    {children}
  </div>
);

export const PaddingLessCol: React.FC<{ className?: string; children?: React.ReactNode }> = ({
  className,
  children,
}) => <div className={clsx("flex-1 min-w-0 pl-0 pr-0", className)}>{children}</div>;

/*
 ** This component is used when we don't want a circle to appear with a step number in the left hand column
 * but want a line to appear instead
 */

const LeftSideBarSpacing = () => (
  // Match LeftSideBarCol's fixed 108px width and breakpoint so continuation rows align
  // with the stepped LeftSideBar rows (card left edge and the vertical connector line).
  <div className="max-[1000px]:hidden flex w-[108px] flex-none flex-col items-center pl-0 pr-0">
    <div className="flex flex-row items-stretch flex-1 flex-wrap h-full w-full">
      <div className="flex self-stretch flex-1 w-full">
        <div className="border-r-0 w-1/2 pl-0 pr-0 flex items-center justify-center">
          <div />
        </div>
        <div className="border-l border-gray-10 w-1/2 pl-0 pr-0 flex items-center justify-center">
          <div />
        </div>
      </div>
    </div>
  </div>
);
export default LeftSideBarSpacing;
